<template lang="pug">
el-container.is-vertical(v-loading="loading").main-container
  el-header(height="var(--stores-header-height)")
    el-carousel(
      height="var(--stores-header-height)"
      arrow="never"
      trigger="click"
      indicator-position="none"
      :initial-index="currentIndex"
      :autoplay="false"
      @change="handleSlideChange"
      ref="carousel")
      el-container.menu
        .menu-item(
          v-for="(article,index) in articles"
          :class="{active: index === currentIndex}"
          @click="goTo(index)"
          ) {{article.shortText || article.text}}
          transition(name="el-zoom-in-center")
            .select-indicator(v-show="index === currentIndex")
      el-carousel-item(v-for="(article,index) in articles"
        :key="index" :class="getArticleClass(article)")
        .dark-background
        h1 {{article.shortText || article.text}} at {{airport.terminal}}
  el-main( style="height: 100%").main
    el-container(v-if="airport.sections.length > 0" style="height: 100%")
      el-header(style="height: var(--stores-menu-height)")
        el-container.is-horizontal
          el-main.section-name(
            v-for="(section,index) in airport.sections"
            :class="{active: index === currentSectionIndex}"
            :key="index")
            div(@click="handleSectionClick(index)").section-item
              | {{airport.code}}-{{section.name}}
        .title {{airport.code}}-{{airport.sections[currentSectionIndex].name}}
          span.dropdown-btn(@click="handleDropdownBtnClick()")
            .icon
        div.dropdown-items-container(:class="{show: isDropdownOpen, hide: !isDropdownOpen}")
          ul
            li(
            v-for="(section,index) in airport.sections"
            :class="{active: index === currentSectionIndex}"
            :key="index",
            @click="handleSectionClick(index)"
            ).item {{airport.code}}-{{section.name}}

      el-main
        transition-group(name="el-zoom-in-top")
          div.store-summary(v-for="(store, index) in filteredStores"
            :key="store.id" v-show="filteredStores.length > 0"
            @click="openModal(store)"
            :class="{'special-offer': isSpecialOfferView && store.specialOffer.active}")
            .info-box(v-if="!isSpecialOfferView || !store.specialOffer.active")
              h3 {{store.name}}
              p {{store.description}}
            .location-box(v-if="!isSpecialOfferView || !store.specialOffer.active")
              h2 {{store.location}}
            .special-offer-background(v-if="isSpecialOfferView && store.specialOffer.active"
             :style="{backgroundImage: `url(${store.specialOffer.background || ''})`}")
              h1.text-center {{store.specialOffer.title}}
              h2.text-center {{store.specialOffer.subtitle}}
              h1.text-center(v-if="store.specialOffer.dates")
                span {{store.specialOffer.dates[0]}}
                span(v-if="store.specialOffer.dates[1]") &nbsp;- {{store.specialOffer.dates[1]}}
        transition(name="el-zoom-in-top")
          div.no-store(v-show="filteredStores.length === 0")
            h5.text-center There are no items of such type

  .store-modal-container(ref="modal" :class="{active: modalOpen}")
    .modal-background
    .store-modal(ref="modal")
      .store-image-container(:class="{'has-image': selectedStore.imageUrl}")
        .store-image(:style="{backgroundImage: 'url(' + selectedStore.imageUrl + ')'}"
        v-if="selectedStore.imageUrl")
      .close-box(@click="closeModal")
      .store-info-container
        h3 {{selectedStore.name}}
        p.desc {{selectedStore.description}}
        footer.clearfix
          .hours(:class="hoursClass")
            h5 hours
            h4
              span {{selectedStore.openAt | toAmPm}}
              span(v-if="selectedStore.openAt !== '24 hours' && selectedStore.closeAt")
                | - {{selectedStore.closeAt | toAmPm}}
            div(v-if="selectedStore.weekendTimes && selectedStore.weekendTimes.active")
              h5(v-if="!selectedStore.customWeekDays.active") weekend hours
              h5(v-else) {{selectedStore.customDays}}
              h4(v-if="selectedStore.weekendTimes && selectedStore.weekendTimes.active")
                span {{selectedStore.weekendTimes.openAt | toAmPm}}
                span(v-if="weekendCloseVisible")
                  | - {{selectedStore.weekendTimes.closeAt | toAmPm}}
          .location
            span {{selectedStore.location}}
</template>

<script>
import ExploreService from '@/services/ExploreService';
import ExploreArticle from '@/components/ExploreArticle';

export default {
  components: { ExploreArticle },
  filters: {
    uppercase(str) {
      return str.toUpperCase();
    },
    lowercase(str) {
      return str.toLowerCase();
    },
    toAmPm(time) {
      if (!time) {
        return time;
      }

      const [hour, minute] = time.split(':');
      if (!hour || !minute) {
        return time;
      }
      const hourInt = parseInt(hour, 10);
      const minuteInt = parseInt(minute, 10);

      if (hourInt === 0 && minuteInt === 0) {
        return '12:00 midnight';
      }

      let postfix = 'am';
      if (hourInt >= 12) {
        postfix = 'pm';
      }

      let hourText = hourInt % 12;
      if (hourText === 0) {
        hourText = 12;
      }

      return `${hourText}:${minute} ${postfix}`;
    },
  },
  props: {
    id: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      airport: {
        id: null,
        name: '',
        code: '',
        sections: [],
        terminal: '',
      },
      articles: [
        {
          text: 'Shops',
          active: true,
        },
        {
          text: 'Dine',
          shortText: 'Dining',
        },
        {
          text: 'Services',
        },
        {
          text: 'Special Offers',
          shortText: 'Offers',
        },
      ],
      stores: [],
      currentIndex: this.index,
      currentSectionIndex: 0,
      selectedStore: {},
      modalOpen: false,
      isDropdownOpen: false,
    };
  },
  computed: {
    filteredStores() {
      return this.stores
        .filter(store => {
          let selectedStoreType = this.articles[
            this.currentIndex
          ].text.toLowerCase();
          if (selectedStoreType === 'special offers') {
            return store.specialOffer && store.specialOffer.active;
          }

          if (selectedStoreType === 'shops') {
            selectedStoreType = 'shopping';
          }
          if (selectedStoreType === 'dine') {
            selectedStoreType = 'dining';
          }
          return store.type[0].toLowerCase() === selectedStoreType;
        })
        .filter(store => {
          const selectedSection = this.airport.sections[
            this.currentSectionIndex
          ];
          return store.section === selectedSection.id;
        })
        .sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },
    hoursClass() {
      return {
        hidden: !this.selectedStore.openAt && !this.selectedStore.closeAt,
        'has-weekend':
          this.selectedStore.weekendTimes &&
          this.selectedStore.weekendTimes.active,
      };
    },
    weekendCloseVisible() {
      return (
        this.selectedStore.weekendTimes.openAt !== '24 hours' &&
        this.selectedStore.weekendTimes.closeAt
      );
    },
    isSpecialOfferView() {
      return (
        this.articles[this.currentIndex].text.toLowerCase() === 'special offers'
      );
    },
  },
  beforeMount() {
    this.currentIndex = parseInt(this.$route.query.index, 10);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      ExploreService.getAirport(this.id)
        .then(({ data }) => {
          this.airport = Object.assign({}, this.airport, data);
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: error.response
              ? error.response.data.errorMessage
              : error.message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
      ExploreService.getAirportStores(this.id)
        .then(({ data }) => {
          this.stores = data.concat();
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: error.response
              ? error.response.data.errorMessage
              : error.message,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleResize() {
      if (window.innerWidth <= 700 ||
        window.innerWidth > window.innerHeight && window.innerWidth <= 825) return;
        this.isDropdownOpen = false;
    },
    getArticleClass(article) {
      return (article.shortText || article.text).toLowerCase();
    },
    goToPrevious(index) {
      if (index === 0) {
        return;
      }
      this.goTo(index - 1);
    },
    goToNext(index) {
      if (index === this.articles.length - 1) {
        return;
      }
      this.goTo(index + 1);
    },
    goTo(index) {
      this.currentIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    inViewport(index) {
      this.articles = this.articles.map(article => {
        const newArticle = article;
        newArticle.active = false;
        return newArticle;
      });
      this.articles[index].active = true;
    },
    goToStores() {
      this.$router.push('stores', { params: { id: this.id } });
    },
    handleSlideChange(index) {
      this.currentIndex = index;
    },
    handleSectionClick(index) {
      this.currentSectionIndex = index;
      this.isDropdownOpen = false;
    },
    handleDropdownBtnClick() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    openModal(store) {
      this.selectedStore = store;
      this.$refs.modal.style.display = 'block';
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      setTimeout(() => {
        this.$refs.modal.style.display = 'none';
      }, 500);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import url('../../static/fonts/rift/stylesheet')
@import url('../../static/fonts/futura/stylesheet')

*
  font-family 'Rift Soft'

.main-container
  height 100vh
  width 100vw
  overflow hidden

.el-main, .el-header
  padding 0

.section-name
  font-size var(--stores-menu-font-size)
  line-height var(--stores-menu-height)
  text-align center
  color white
  background-color #cbcbcb
  cursor pointer

  &.active
    background-color #747474

  .section-item
    font-family 'Futura Lt BT'
    text-transform uppercase

.dining
  background-image url('../../static/images/dine.jpg')

.shops
  background-image url('../../static/images/shops.jpg')

.services
  background-image url('../../static/images/services.jpg')

.offers
  background-image url('../../static/images/offers.jpg')

.el-carousel__container
  .menu
    position relative
    z-index 10
    font-size var(--stores-header-menu-font-size)
    color #fff
    top var(--stores-header-menu-top)
    align-items center
    justify-content space-evenly

    .menu-item
      font-family 'Futura Lt BT'
      text-transform uppercase
      margin 0
      cursor pointer

      .select-indicator
        background-color white
        width 100%
        margin-top var(--stores-header-select-indicator-margin-top)
        height var(--stores-header-select-indicator-height)

.el-carousel__item
  background-size cover
  background-position center
  display flex
  align-items center
  justify-content center

  h1
    color white
    position relative
    font-family 'Rift Soft'
    font-size var(--stores-header-title-font-size)
    margin 0
    text-align center
    white-space nowrap
    top var(--stores-header-title-top)

  .dark-background
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background-color rgba(0, 0, 0, .5)

.el-carousel__item:nth-child(2n)
  background-color #99a9bf

.el-carousel__item:nth-child(2n+1)
  background-color #d3dce6

.main-header
  height var(--stores-menu-height)

.store-summary
  height var(--stores-store-summary-height)
  border-bottom 1px solid #acacac
  box-sizing border-box
  display flex
  align-items center
  justify-content space-around
  cursor pointer

  h3
    font-family 'Futura Md BT'
    font-size var(--stores-store-summary-h3-font-size)
    margin 0

  p
    font-family 'Futura Lt BT'
    font-size var(--stores-store-summary-p-font-size)
    margin var(--stores-store-summary-p-margin-top) 0
    overflow hidden
    line-height var(--stores-store-summary-p-line-height)
    height var(--stores-store-summary-p-height)

  &:first-of-type
    border-top 1px solid #acacac

  .info-box
    float left
    width var(--stores-info-box-width)
    padding-left var(--stores-info-box-left)

  .location-box
    width var(--stores-location-box-width)
    float right
    font-size var(--stores-location-box-font-size)
    position relative
    height 100%
    overflow hidden

    h2
      margin 0
      position absolute
      width 100%
      top 50%
      text-align center
      transform translateY(-50%)

  &.special-offer
    position relative
    padding-top 25%

    .special-offer-background
      position absolute
      top 0
      right 0
      left 0
      bottom 0
      background-size cover
      background-position center

      h1, h2
        font-family 'Futura Md BT'
        color white
        text-transform uppercase
        text-shadow 0 2px 3px rgba(0, 0, 0, .3)

.store-modal-container
  position absolute
  top 0
  left 0
  right 0
  width 100vw
  height 100vh
  z-index 100
  display none

  .modal-background
    position absolute
    top 0
    left 0
    right 0
    width 100%
    height 100%
    background-color rgba(0, 0, 0, 0)
    transition all .5s ease-in-out

  &.active
    .modal-background
      background-color rgba(0, 0, 0, .5)

  &.active
    .store-modal
      top 50%
      transform translate(-50%, -50%)

  .store-modal
    position absolute
    width var(--stores-modal-width)
    background white
    left 50%
    transform translate(-50%, 0)
    top 100%
    transition all .5s ease-in-out

    .store-image-container
      height 90px

      &.has-image
        height var(--stores-modal-image-height)

      .store-image
        height 100%
        width 100%
        background-position center
        background-size cover

    .store-info-container
      padding var(--stores-modal-info-box-padding-top) var(--stores-modal-info-box-padding-right)

      h3
        font-family 'Futura Md BT'
        font-size var(--stores-modal-info-box-h3-font-size)
        margin 0

      p
        font-family 'Futura Lt BT'
        font-size var(--stores-modal-info-box-desc-font-size)
        margin 4px 0
        overflow auto
        line-height 1.4
        max-height var(--stores-modal-info-box-desc-max-height)

      .clearfix
        display flex
        justify-content center
        align-items center

        &::after
          content ''
          clear both
          display table

      .hours, .location
        width 50.5%

      .location

      .hours
        h5
          font-family 'Futura Lt BT'
          font-size var(--stores-modal-clearfix-h5-font-size)
          margin var(--stores-modal-clearfix-h5-margin-top) 0

        h4
          font-family 'Futura Md BT'
          font-size var(--stores-modal-clearfix-h4-font-size)
          margin 0

        &.hidden
          opacity 0

        &.has-weekend
          h5
            font-size 13px

          h4
            font-size 16px

      .location
        position relative
        text-align right

        span
          position relative
          font-family 'Futura Md BT'
          margin 0
          font-size var(--stores-modal-location-span-font-size)
          float right

    .close-box
      width var(--stores-modal-close-btn-width)
      height var(--stores-modal-close-btn-height)
      background-image url('../../static/images/close-box.png')
      background-size cover
      position absolute
      right var(--stores-modal-close-btn-right)
      top var(--stores-modal-close-btn-top)
      cursor pointer


.title
  display none
  font-size var(--stores-menu-header-font-size)
  line-height var(--stores-menu-height)
  color #fff
  background-color #cbcbcb
  text-align center
  font-family 'Futura Lt BT'
  text-transform uppercase

  .dropdown-btn
    width var(--stores-menu-btn-width)
    height var(--stores-menu-btn-height)
    position absolute
    right var(--stores-menu-btn-right)
    top var(--stores-menu-btn-top)

    &:hover
      cursor pointer

    .icon
      width 100%
      height 100%
      background-image url("data:image/svg+xml,%3Csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='caret-down' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' class='svg-inline--fa fa-caret-down fa-w-10 fa-3x'%3E%3Cpath fill='white' d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z' class=''%3E%3C/path%3E%3C/svg%3E")

.dropdown-items-container
  width 100%
  background-color #cbcbcb
  position absolute
  color #ffff
  z-index 5
  top var(--stores-menu-container-top)
  transition all 0.15s
  transform-origin top left

  &.hide
    transform scaleY(0)

  &.show
    transform scaleY(1) translateY(0)

  ul
    list-style-type: none
    margin 0
    padding 0

  .item
    font-size var(--stores-menu-container-item-font-size)
    padding-left var(--stores-menu-container-item-padding-left)
    line-height var(--stores-menu-container-item-line-height)
    font-family 'Futura Lt BT'
    text-transform uppercase

    &:hover
      background-color #747474
      cursor pointer

    &.active
      background-color #747474

@media screen and (max-width: 1024px)
  .el-carousel__container
  .menu

    .menu-item
      margin 0 25px

@media screen and (max-width 825px) and (orientation landscape)
  .el-carousel__container

    .menu
      justify-content space-around

      .menu-item
        margin 0

  .section-name
    display none

  .title
    display block

  .store-modal-container
    .store-modal
      .store-image-container
          height 0

@media screen and (max-width 700px)
  .el-carousel__container

    .menu
      justify-content space-around

      .menu-item
        margin 0

  .section-name
    display none

  .title
    display block

  .store-modal-container
    .store-modal
      .store-image-container
        height 0
</style>



// WEBPACK FOOTER //
// src/components/ExploreAirportStores.vue